// DetailRow.vue
<template>
  <div>
    <div>
      <div class="row row-inside custom-wrapper is-even">
        <div class="row row-inside">
          <div class="flex md10 offset--md1 my-2">
            <div class="row row-inside title">
              <div class="flex md1">Nature</div>
              <div class="flex md2">Niveau du retour</div>
              <div class="flex md1">Date</div>
              <div class="flex md1">Type</div>
              <div class="flex md3">Motif / action</div>
              <div class="flex md2">Commentaire retour</div>
              <div class="flex md2">Créateur</div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row row-inside custom-wrapper detail-row"
        v-for="(item, index) in rowData.historique"
        v-bind:class="[index % 2 ? isodd : iseven]"
      >
        <div class="row row-inside" @click="openModal(item)">
          <div class="flex md10 offset--md1 my-2">
            <div class="row row-inside">
              <div class="flex md1">
                <va-chip
                  class="fullwidth"
                  :color="item.hist_type === 'retour' ? 'info' : 'success'"
                  >{{ item.hist_type }}</va-chip
                >
              </div>
              <div class="flex md2">
                <va-chip
                  v-if="item.hist_type === 'retour'"
                  class="fullwidth"
                  :color="statusColor(item)"
                  >{{ statusText(item) }}</va-chip
                >
              </div>
              <div class="flex md1">
                {{ item.date_element }}
              </div>
              <div class="flex md1">
                {{ item.hist_type === "retour" ? textType(item) : "Action" }}
              </div>
              <div class="flex md3">
                {{
                  item.hist_type === "retour"
                    ? item.motif_text
                    : item.commentaire
                }}
              </div>
              <div class="flex md2">
                {{ item.hist_type === "retour" ? item.commentaire : "" }}
              </div>
              <div class="flex md2">
                {{ item.prenom + " " + item.nom }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import EventBus from "../../services/eventBus";
import axios from "axios";
import moment from "moment";
moment.locale("fr");
export default {
  name: "detail-row-retours",
  components: {
    Vuetable,
  },
  data() {
    return {
      iseven: "is-even",
      isodd: "is-odd",
      perPage: 200,
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  mounted() {},
  methods: {
    textType(item) {
      if (item.type === "journal") {
        let text = "journal - ";
        if (item.numero) {
          return text + "N°" + item.numero;
        } else {
          return item.date_parution
            ? text +
                "HS " +
                moment(item.date_parution, "YYYY-MM-DD").format("MMMM YYYY")
            : "HS " +
                moment(item.date_previsionnelle, "YYYY-MM-DD").format(
                  "MMMM YYYY"
                );
        }
        return text;
      } else {
        return item.type;
      }
    },
    statusColor(item) {
      //retour definitif, sending is blocked
      if (item.definitif) {
        return "danger";
      }
      if (item.level === 0) {
        return "success";
      }
      if (item.level === 1) {
        return "info";
      }
      if (item.level === 2) {
        return "warning";
      }
      if (item.level >= 3) {
        return "danger";
      }
      return "gray";
    },
    statusText(item) {
      if (item.definitif) {
        return "Retour définitif";
      }
      if (item.level === 0) {
        return "Aucun retour actif";
      }
      if (item.level === 1) {
        return "1er retour";
      }
      if (item.level === 2) {
        return "2eme retour";
      }
      if (item.level === 3) {
        return "3eme retour - bloqué";
      }
      if (item.level >= 3) {
        return item.level + " retours - bloqué";
      }
      return "gray";
    },
    openModal(item) {
      if (item.hist_type === "action") {
        EventBus.$emit("OPEN_ACTION_MODAL", item);
      } else {
        EventBus.$emit("OPEN_RETOUR_MODAL", item);
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
.custom-wrapper {
  padding: 3px;
}
.custom-wrapper:hover {
  background-color: #eee;
}
.is-even {
  background-color: #ffffff;
}
.is-odd {
  /* background-color: #f5f8f9; */
  background-color: #f5f8f9;
}
.fullwidth {
  width: 95%;
}
.title {
  padding: 10px 0;
  font-weight: bold;
  color: black;
}
</style>
